import React from "react"
import { AppContextType } from "../../../../context/AppContext"
import useAppContext from "../../../../hooks/useAppContext"
import { CompanyNameType } from "../../../../static/types/commonTypes/companyNameType"
import { DateType } from "../../../../static/types/commonTypes/dateType"
import CompanyName from "../../../commonComponents/CompanyName"
import DateComponent from "../../../commonComponents/DateComponent"

const ChangeDenomination: React.FC = () => {

    const {

        companyNameChangeEffectiveDate,
        setCompanyNameChangeEffectiveDate,
        setCompanyNameChangeEffectiveDateValidity,
        companyNameChangeEffectiveDateChecked,

        companyNameChange,
        setCompanyNameChange,

        companyNameUpdate, setCompanyNameUpdate,
        setCompanyNameUpdateValidity,
        companyNameUpdateChecked,

    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setCompanyNameChangeEffectiveDate ({...companyNameChangeEffectiveDate, ...data});
    const updateCompanyNameUpdate = (data: Partial<CompanyNameType>) => setCompanyNameUpdate ({...companyNameUpdate, ...data});
    
    return(
        <div>
            <div className='col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor="denomination" className="col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className = 'form-select w-75'
                    id = "denomination"
                    onChange = {( e ) => setCompanyNameChange( Number( e.target.value ))}
                    value = { companyNameChange }
                >
                    <option value = { 0 }> Aucune modification </option>
                    <option value = { 1 }> Nouvelle dénomination </option>
                </select>
            </div>

            {
                companyNameChange === 1 &&
                    <div className = "mt-3">
                        <div className="col-sm-7">
                            <DateComponent
                                id="dateEffetDenomination"
                                date = { companyNameChangeEffectiveDate }
                                draftFieldName = "companyNameChangeEffectiveDate"
                                changeDate = { updateDate }
                                dateLabel = "Date d'effet"
                                checked = { companyNameChangeEffectiveDateChecked }
                                onValidationChange = {( isValid: boolean ) => setCompanyNameChangeEffectiveDateValidity( isValid )}
                                required = { false }
                        />
                        </div>
                        <div>
                            <CompanyName
                                changeCompanyName = { updateCompanyNameUpdate }
                                companyName = { companyNameUpdate }
                                draftFieldName = "companyNameUpdate"
                                checked = { companyNameUpdateChecked }
                                onValidationChange = {( isValid: boolean ) => setCompanyNameUpdateValidity( isValid )}
                                showClientReference = { false }
                                showRequiredIndicator = { false }
                            />
                        </div>
                        
                    </div>
            }
        </div>
    )
}

export default ChangeDenomination